import * as z from "zod";

export const getAutoMergeProgress = {
  name: "getAutoMergeProgress" as const,
  input: z.object({ workflowId: z.string() }),
  output: z.object({
    status: z.enum(["running", "done", "failed"]),
    processed: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
  }),
};
